import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { IThreatAssessmentTeam } from '../../../../../shared/models/contact';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { SpinnerComponent } from '../../../../components/spinner/spinner.component';

@Component({
  selector: 'assigned-user',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SpinnerComponent
  ],
  templateUrl: './assigned-user.component.html',
  styleUrl: './assigned-user.component.css'
})
export class AssignedUserComponent implements OnInit {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection2 = new EventEmitter<any>();

  yesNo = EYesNo;
  
  threatTeam: IThreatAssessmentTeam[] = [];
  usersList: IThreatAssessmentTeam[] = [];
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  selectedMemberId: number | null = null;
  messageModal: string | null = null;

  loadingContacts: boolean = false;
  loadingTeam: boolean = false;
  loading: boolean = false;

  constructor(
    private contactsService: ContactsService,
    private userDataService: UserDataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.loadUsers();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });

    this.loadThreatAssessmentTeamMembers();
  };

  // load all users
  loadUsers(): void {
    this.loadingContacts = true;
    this.updateLoadingState()
    this.contactsService.getUsers(this.currentBuildingId!).subscribe({
      next: (users: IThreatAssessmentTeam[]) => {
        this.usersList = users;
        // Sort the list after retrieving Users List.
        if (this.usersList.length > 0) {
          this.loadThreatAssessmentTeamMembers();
        }
        this.loadingContacts = false;
        this.updateLoadingState();
      },
      error: (error: any) => {
        this.loadingContacts = false;
        this.updateLoadingState();
        console.error('Error loading users:', error.message);
      }
    });
  };

  loadThreatAssessmentTeamMembers(): void {
    this.loadingTeam = true;
    this.updateLoadingState();
    if (this.currentCaseId) {
      this.contactsService.getThreatAssessmentTeam(this.currentCaseId).subscribe({
        next: (res) => {
          if (res.found !== false) {
            this.threatTeam = res.team
            .map((item: any) => this.usersList.find(contact => contact.user_id === item.user_id))
            .filter((contact: IThreatAssessmentTeam | undefined): contact is IThreatAssessmentTeam => contact !== undefined);
            if (this.threatTeam.length > 0) {
              this.threatTeam.sort((a, b) => a.name!.localeCompare(b.name!));
              this.selectedMemberId = this.roarAssignmentFormData.user_assigned ? this.roarAssignmentFormData.user_assigned : this.threatTeam[0].user_id ?? null;
            }
            this.loadingTeam = false;
            this.updateLoadingState();
          }
        },
        error: (err) => {
          this.loadingTeam = false;
          this.updateLoadingState();
          console.error(err);
        }
      });
    }
  }

  updateLoadingState() {
    this.loading = this.loadingContacts || this.loadingTeam;
  }

  onMemberChange(event: any): void {
    this.selectedMemberId = event.target.value;
  };

  saveAssignedUser() {
    if (this.selectedMemberId) {
      const data: any = {};
      data['user_assigned'] = this.selectedMemberId;
      this.onSaveSection2.emit(data);
    }
  }
}
